import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router, Event, ActivatedRoute } from '@angular/router';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { EventEmitterService } from 'src/app/core/services/v2/event-emitter.service';
import { MarketPlaceService } from '../../../market-place/market-place.service';
import { FilterCriteria } from '../../../core/models/market-place/product/filterCriteria.model';
import { debug } from 'console';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-layout-header',
  templateUrl: './layout-header.component.html',
  styleUrls: ['./layout-header.component.scss']
})
export class LayoutHeaderComponent implements OnInit, AfterViewInit {
  @Input() photoUrlRecieve: string;
  shoppingCartNumber: number;
  categoryName: string = '';
  subCategoryName: string = '';
  productName: string = '';
  searchName = '';
  IsCheckOutPage: boolean = false;
  IsSearchDisplay: boolean = false;
  IsShoppingCart: boolean = false;
  shoppingCount: number = 0;
  IsFaviouriteProduct: boolean = false;
  IsOrderHistory: boolean = false;
  isShoppingCartIcon: boolean = false;
  userid: number;
  userName: string;
  greetings: string;
  shortName: string;
  isImpersonating: boolean = false;
  isGlobalSearchShow: boolean = false;
  currentRoute: string;
  showCartButton: boolean = false;

  constructor(private router: Router, private practiceService: PracticeService, private userService: UserService,
    private eventEmitterService: EventEmitterService, private marketPlaceService: MarketPlaceService,
    private activatedRoute: ActivatedRoute, private changeDetect: ChangeDetectorRef
  ) {
    this.currentRoute = "";
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show progress spinner or progress bar
        console.log('Route change detected');
      }

      if (event instanceof NavigationEnd) {
        // Hide progress spinner or progress bar
        this.currentRoute = event.url;
        this.showGlobalSearch();
        console.log(event);
      }

      if (event instanceof NavigationError) {
        // Hide progress spinner or progress bar

        // Present error to user
        console.log(event.error);
      }
      if (this.userid != undefined) {
        //this.marketPlaceService.getShoppingCart(this.userid).subscribe(res => {
        //  this.shoppingCartNumber = res.length;
        //});
      }
    });


  }



  async ngOnInit() {
    // this.getCartCount();
    this.showGlobalSearch();

    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.userid = userDetails.id;
        this.userName = userDetails.name;
        const matches = this.userName.match(/\b(\w)/g);
        this.shortName = matches.slice(0, 2).join('');
        this.isImpersonating = userDetails.isImpersonating;
      },
      (error) => { console.error(error); }
    );

    if (this.eventEmitterService.subsVarLayout == undefined) {
      this.eventEmitterService.subsVarLayout = this.eventEmitterService.
        invokeLayoutComponentFunction.subscribe((name: string) => {
          this.marketPlaceService.getShoppingCart(this.userid).subscribe(res => {
            this.shoppingCartNumber = res.length;
          });

        });
    }
    const today = new Date();
    const curHr = today.getHours();

    if (curHr < 12) {
      this.greetings = 'Good Morning';
    } else if (curHr < 18) {
      this.greetings = 'Good Afternoon';
    } else {
      this.greetings = 'Good Evening';
    }
  }

  ngAfterViewInit() {
  }
  signOut() {
    window.location.href = `/Session/SignOut`;
  }

  settingPage() {
    this.router.navigate(['physician/profile/signIn']);
  }


  stopImpersonating() {
    this.userService.cancelImpersonate();
  }
  orderHistory() {
    this.router.navigate(['patient/marketplace/orderHistory']);
  }
  favorites() {
    this.router.navigate(['patient/marketplace/favorite']);
  }

  savedAddress() {
    if (this.router.url != 'patient/profile') {
      this.router.navigate(['patient/profile']);
      this.router.navigate(["patient/profile"]).then(() => {
        // do whatever you need after navigation succeeds
        this.eventEmitterService.onPatientProfileComponentButtonClick();
      });
    }
  }

  showGlobalSearch() {
    if (this.router.url.includes('patient/marketplace')) {
      this.isGlobalSearchShow = true;
      this.showCartButton = true;
      this.getCartCount();
    }
    else {
      this.isGlobalSearchShow = false;
      this.showCartButton = false;
    }
  }
  callGoToSearchPage(searchText: string) {
    // this.eventEmitterService.onSearchClick(searchText);
    this.router.navigate(['./marketplace/search'], { relativeTo: this.activatedRoute, queryParams: { search: searchText } });
  }
  goToShoppingCartPage() {
    let roleBaseUrl = this.router.url.includes('patient') ? 'patient' : 'physician';
    this.router.navigateByUrl(`/${roleBaseUrl}/marketplace/shoppingCart`).then(() => {
      this.marketPlaceService.removeBreadCrumb();
      //this.IsShoppingCart = true;
      //this.IsSearchDisplay = false;
      //this.IsCheckOutPage = false;
    });
  }
  getCartSum() {

    if (this.marketPlaceService != undefined) {
      this.marketPlaceService.shoppingCartInfo.subscribe((res) => {
        let p1 = res;
        this.shoppingCartNumber = p1.length;
      })
    }
  }
  async getCartCount() {

    if (this.userid) {
      this.marketPlaceService.getShoppingCart(this.userid).subscribe(res => {
        this.shoppingCartNumber = res.length;
      });
    }
    else {
      let cartInfo = await this.marketPlaceService.getShoppingCartInfo();
      this.shoppingCartNumber = cartInfo ? cartInfo.length : 0;
      this.changeDetect.detectChanges();
    }
  }
  setBreadCrumbName() {
    this.categoryName = '';
    this.subCategoryName = '';
    this.productName = '';
    this.searchName = '';
    this.IsShoppingCart = false;
    this.shoppingCount = 0;
    this.IsFaviouriteProduct = false;
    this.IsOrderHistory = false;
  }
  async getShoppingCartInfo() {
    let cartInfo = await this.marketPlaceService.getShoppingCartInfo();
    this.shoppingCartNumber = cartInfo.length;
    this.marketPlaceService.shoppingCartInfo.next([...cartInfo]);
    // this.shoppingCartInfo = [...cartInfo];
  }
}
